module.exports = __webpack_public_path__ + "static/expectimg2-e64c10e49a7179151245fa5fcc3bdbb3.jpg";